
import { useState, useEffect } from "react";
import { usePlaylist } from "../hooks/usePlayliste";
import "../css/playlist.css";
// import { SongItem } from "../components/SongItem";

// export function SongSearchLocal({ onSelect }) {
//     const [query, setQuery] = useState("");
//     const [results, setResults] = useState([]);

//     const isLocal = window.location.hostname === "localhost";
//     const API_URL = isLocal ? "http://localhost:5000/api" // backend local sans /api 
//         : "/api"; // backend prod avec /api

//     async function handleSearch(e) {
//         const q = e.target.value;
//         setQuery(q);
//         if (q.length < 2) return;
//         const res = await fetch(`${API_URL}/songs/search?query=${q}`);
//         setResults(await res.json());
//     }

//     return (
//         <div>
//             <h3>Recherche locale</h3>
//             <input value={query}
//                 className="playlist-input"
//                 onChange={handleSearch} placeholder="Titre ou artiste" />

//             {results?.map(song => (
//                 <div key={song.id}
//                     className="song-result"
//                     onClick={() => onSelect(song)}>
//                     {song.title} — {song.artist}
//                 </div>
//             ))}
//         </div>
//     );
// }

export function SongSearchDeezer({ onSelect }) {
    const [query, setQuery] = useState("");
    const [results, setResults] = useState([]);

    const isLocal = window.location.hostname === "localhost";
    const API_URL = isLocal ? "http://localhost:5000/api" // backend local sans /api 
        : "/api"; // backend prod avec /api


    async function handleSearch(e) {
        const q = e.target.value;
        setQuery(q);
        if (q.length < 2) return;
        const res = await fetch(`${API_URL}/songs/deezer?query=${q}`);
        setResults(await res.json());
    }

    //`${API_URL}/songs/deezer?query=${query}`

    // async function fetchCover(deezerId) {
    //     const res = await fetch(`https://api.deezer.com/track/${deezerId}`);
    //     const data = await res.json();
    //     return data.album?.cover_medium;
    // }


    return (
        <div>
            <h3>Rechercher un morceau</h3>
            <input value={query}
                className="playlist-input"
                onChange={handleSearch} placeholder="Titre ou artiste" />

            <div className="deezer-grid">
                {results?.map(song => (
                    <div className="song-card song-result" onClick={() => onSelect(song)}
                        key={song.id}>
                        {/* {console.log(song)} */}
                        {/* song.album.cover_medium && <img src={song.album.cover_medium} alt={song.title} className="song-cover" />}                     */}
                        {song.cover && (<img className="song-cover" src={song.cover} alt={song.title} />)}
                        {/* <img
                            src={song.cover || "/placeholder.jpg"}
                            alt={song.title}
                            className="song-cover"
                        /> */}
                        <div className="song-info">
                            {song.title} - {song.artist}
                            {/* <strong></strong> */}
                            <span>{song.artist.name}</span>
                        </div>
                        {/* {song.preview && ( <audio src={song.preview} controls /> )} */}
                    </div>
                    // <div key={song.id}
                    //     className="song-result"
                    //     onClick={() => onSelect(song)}>
                    //     {song.title} — {song.artist}
                    // </div>
                ))}
            </div>
        </div>
    );
}

export function MySelectedSongs({ temp, onRemove }) {
    const nbSongs = (temp?.length ?? 0)
    const remaining = 2 - nbSongs;

    return (
        <div>
            <h3>Vos choix</h3>

            {(nbSongs === 0) && <p>Aucun morceau sélectionné</p>}

            {nbSongs > 0 && temp.map(song => (
                <div key={song.id}>
                    <strong>{song.title}</strong> — {song.artist}
                    <button
                        className="btn btn-remove"
                        onClick={() => onRemove(song.id)}>Retirer</button>
                </div>
            ))}

            <p>
                {remaining > 0
                    ? `Il vous reste ${remaining} morceau${remaining > 1 ? "x" : ""} à choisir`
                    : "Vous avez choisi vos 2 morceaux 🎉"}
            </p>
        </div>
    );
}

export function CurrentPlaylist({ songs }) {
    return (
        <div>
            <h3>Playlist actuelle</h3>

            {(!songs || (songs?.length ?? 0) === 0) && <p>Aucun morceau choisi pour l’instant</p>}

            {(songs?.length ?? 0) > 0 && songs.map(song => (
                <div key={song.id} className="playlist-item">
                    <strong>{song.title}</strong> — {song.artist}
                    <br />
                    <small>Choisi par : {song.chosenBy.name}</small>
                </div>
            ))}
        </div>
    );
}

export function MyFinalChoices({ mySongs }) {
    const remaining = 2 - (mySongs?.length ?? 0);

    return (
        <div>
            <h3>Vos choix validés</h3>

            {(!mySongs || mySongs?.length === 0) && (
                <p>Aucun morceau choisi pour l'instant</p>
            )}


            {(mySongs?.length ?? 0) > 0 && mySongs.map(song => (
                <div key={song.id}>
                    <strong>{song.title}</strong> — {song.artist}
                </div>
            ))}

            <p>
                {remaining > 0
                    ? `Il vous reste ${remaining} morceau${remaining > 1 ? "x" : ""} à choisir`
                    : "Vous avez choisi vos 2 morceaux 🎉"}
            </p>
        </div>
    );
}



export default function Playlist() {
    const email = localStorage.getItem("inviteEmail");
    // const { songs, loading, selectSong, unselectSong } = usePlaylist(email);
    const {
        // searchLocal,
        // searchDeezer,
        temp,
        current,
        // playlist,
        mySongs,
        addTemp,
        removeTemp,
        validate,
        areSameChoices
    } = usePlaylist(email);

    // if (loading) return <p>Chargement…</p>;
    const remaining = 2 - (temp?.length ?? 0);

    const [isRegistered, setIsRegistered] = useState(null);

    const isLocal = window.location.hostname === "localhost";
    const API_URL = isLocal ? "http://localhost:5000/api" // backend local sans /api 
        : "/api"; // backend prod avec /api

    useEffect(() => {
        async function checkInvite() {
            try {
                const res = await fetch(`${API_URL}/guest?email=${email}`);
                if (!res.ok) {
                    setIsRegistered(false);
                    return;
                }
                // const data = await res.json();
                setIsRegistered(true);
            } catch (err) {
                setIsRegistered(false);
            }
        }

        checkInvite();
    }, [API_URL, email]);


    return (
        <div>
            <h1>Playlist du mariage</h1>

            {isRegistered === false ? (
                <div className="invite-warning">
                    <p>
                        Pour choisir vos morceaux, merci de d’abord compléter votre invitation.
                    </p>
                    <a href="/invitation" className="btn btn-validate">
                        Aller à la page Invitation
                    </a>
                </div>
            ) :
                <>
                    <h2>Choisissez vos 2 morceaux</h2>

                    {/* <MyFinalChoices mySongs={mySongs} /> */}

                    {/* <h2>Email</h2>
            <p>{email}</p> */}

                    <MySelectedSongs temp={temp} onRemove={removeTemp} />

                    {remaining > 0 && (
                        <>
                            {/* <SongSearchLocal onSelect={addTemp} /> */}
                            <SongSearchDeezer onSelect={addTemp} />
                        </>
                    )}


                    {(temp?.length ?? 0) === 2 && !areSameChoices(temp, mySongs) && (
                        <button
                            className="btn btn-validate"
                            onClick={validate}>Valider mes choix</button>
                    )}
                </>
            }


            <CurrentPlaylist songs={current} />
        </div>
    );

}



// export function FullPlaylist({ songs }) {
//     return (
//         <div>
//             <h3>Playlist complète</h3>

//             {songs.length === 0 && <p>Aucun morceau choisi pour l’instant</p>}

//             {songs?.map(song => (
//                 <div key={song.id} className="playlist-item">
//                     <strong>{song.title}</strong> — {song.artist}
//                     <br />
//                     <small>Choisi par : {song.chosenBy.name}</small>
//                 </div>
//             ))}
//         </div>
//     );
// }



    /* <FullPlaylist songs={playlist} /> */ 
    /*             
             {songs?.map(song => (
                 <SongItem
                     key={song.id}
                     song={song}
                     isMine={song.chosenBy === email}
                     onSelect={selectSong}
                     onUnselect={unselectSong}
                 />
             ))}  */




    // return (
    //     <div>
    //         <h2>Playlist du mariage</h2>

    //         <p>Pour l'ambiance de la soirée, nous souhaitons que chaque invité choisisse 2 chansons pour la playlist partagée.<br />
    //             [PROTOCOLE D'ENVOI]
    //         </p>

    //         {/* {songs?.map(song => (
    //             <SongItem
    //                 key={song.id}
    //                 song={song}
    //                 isMine={song.chosenBy === email}
    //                 onSelect={selectSong}
    //                 onUnselect={unselectSong}
    //             />
    //         ))} */}
    //     </div>
    // );